"use client";

import React from "react";
import {Grid, GridItem, Stack, SimpleGrid, Box, Divider} from "@chakra-ui/react";
import Image from "next/image";
import dynamic from "next/dynamic";

import FooterBackground from "public/footer/background.png";

import FooterBranding from "./components/footerBranding";

const SafeView = dynamic(() => import("@/components/safeView"), {ssr: false});

const FooterService = dynamic(() => import("./components/footerServices"), {ssr: false});
const FooterIaasServices = dynamic(() => import("./components/footerIaasServices"), {
  ssr: false,
});
const FooterSupport = dynamic(() => import("./components/footerSupport"), {ssr: false});
const FooterPolicies = dynamic(() => import("./components/footerPolicies"), {ssr: false});

const FooterSocial = dynamic(() => import("./components/footerSocial"), {ssr: false});

function Footer() {
  return (
    <Box position="relative" pt={{base: 0, md: "3.5rem"}}>
      <Image
        src={FooterBackground}
        alt="Footer background"
        fill
        style={{objectFit: "cover"}}
        placeholder="blur"
        quality={70}
        priority={false}
      />
      <Stack position="relative" zIndex={1}>
        <SafeView>
          <Grid
            gap={{base: 4, md: 8}}
            p={{base: 3, sm: 6}}
            templateColumns="repeat(3, 1fr)"
          >
            <GridItem colSpan={{base: 3, md: 1}}>
              <FooterBranding />
            </GridItem>

            <GridItem colSpan={{base: 3, md: 2}}>
              <Stack spacing={{base: 4, sm: 6}}>
                <SimpleGrid columns={{base: 1, sm: 2, md: 4}} spacing={{base: 6}}>
                  <FooterService />
                  <FooterIaasServices />
                  <FooterSupport />
                  <FooterPolicies />
                </SimpleGrid>
              </Stack>
            </GridItem>
          </Grid>
        </SafeView>

        <Divider color="#ababab" />

        {/* Social links */}
        <FooterSocial />
      </Stack>
    </Box>
  );
}

export default Footer;
